export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.vendor_billing_types) {
        return {...state, ...payload.vendor_billing_types};
      }
      return state;
    }
  }
};
